import React from 'react'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'
import FormTemplate from './Template'

const BodyControl = (props) => {
  return <FormTemplate props={props} layout="body" />
}

export const bodyControlTester = rankWith(3, scopeEndsWith('body'))

export default withJsonFormsControlProps(BodyControl)
